import { realtimeDb, firebaseAuth } from '../config/constants'
import log from './logger'

function timeDelay(x){
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(x);
    }, 2000);
  });
}

export async function getCurrentUser(){
  let user = await firebaseAuth().currentUser;
  //log.debug(user.displayName);
  return user;
  //let x = await timeDelay(10);
//return x;

}

//firebase.auth().currentUser
/*
export function getCurrentUser() {
  //var user = firebaseAuth.currentUser;
  //log.debug(user);

  return firebaseAuth().onAuthStateChanged().then(function(user){
    if(user){
      return user;
    }else{
      return null;
    }
  });

  //return user;

  // return new Promise(function (resolve, reject) {
  //   firebaseAuth().onAuthStateChanged(function (user) {
  //     if (user) {
  //       log.debug('LOGIN_SUCCESS', user);
  //       resolve(user);
  //     } else {
  //       log.debug('LOGIN_FAIL');
  //       reject(Error('It broke'));
  //     }
  //   });
  // });

}
*/

export function auth (email, pw) {
  return firebaseAuth().createUserWithEmailAndPassword(email, pw)
    .then(saveUser)
}

export function logout () {
  return firebaseAuth().signOut()
}

export function login (email, pw) {
  // logout first.
  firebaseAuth().signOut();
  return firebaseAuth().signInWithEmailAndPassword(email, pw)

  // firebaseAuth().signOut().then(function() {
  //   console.log('Signed Out');
  //   return firebaseAuth().signInWithEmailAndPassword(email, pw)
  // }, function(error) {
  //   console.error('Sign Out Error', error);
  // });

}

export function resetPassword (email) {
  return firebaseAuth().sendPasswordResetEmail(email)
}

export function saveUser (user) {
  return realtimeDb.child(`users/${user.uid}/info`)
    .set({
      email: user.email,
      uid: user.uid
    })
    .then(() => user)
}



// WEBPACK FOOTER //
// ./src/helpers/auth.js